export const DefaultOppResponse = {
  _id: "5fd8cebfc44d6718100ee83b",
  name: "Senior Analyst - Mock",
  jobTitle: "Senior Analyst - Mock",
  summary:
    "<p>Role Purpose&nbsp;&nbsp;&nbsp;</p><p><br></p><p>As a Senior Analyst you will be responsible for the delivery of insights, analysis, creation of dashboards and presentation to Gaming team and other key stakeholders.</p><p><br></p><p>The role would require daily coordination with the Gaming team to assess performance of the product and guide their next steps. You will have the ability to understand database structure and logic and enjoy the hands-on approach. You will be the expert in conducting detailed analysis and modelling of customer data.</p><p><br></p><p>You will be responsible for driving and supporting analytical solutions for our Casino. You will have the expertise to analyse and predict customer behaviour in order to create better UX and increase profitability. The ideal candidate will have deep understanding of Gaming and enjoy working in that field.</p><p><br></p><p>Reporting to the Head of Gaming and Compliance Analytics within the BI Team you will also have the support of 2 direct reports to guide &amp; enhance their capabilities.</p><p><br></p><p>Key Responsibilities</p><p><br></p><p>Build strong relationships with Casino leaders to understand daily challenges.</p><p>Provide the Gaming team with ad-hoc, or regular reporting to support ongoing operations</p><p>Work effectively with business counterparts to conceive, specify, pilot and implement analytical applications and tools</p><p>Use abstract thinking and problem solving skills to identify business opportunities and pinpoint problems</p><p>Take ownership of the analysis and reporting on campaigns and highlight ROI on marketing strategies.</p><p>Present your actionable insight to senior stakeholders on a regular basis to drive strategic business impact.</p><p>Application of Predictive and unsupervised models developed by the central BI team</p><p>Demonstrate the value of your analytical outputs in terms of decision making improvement and underling revenue or customer behaviour impact</p><p>Educate business users and leaders on how to measure performance</p><p>Drive analytical projects though to delivery and embed them within the organisation</p><p>Prototype (craft) reports but ensure that become automated by driving through the reporting team</p><p>Encourages communication and collaboration across the business, team and stakeholders in order to build strong relationships and develop cross functional working</p><p>Be a mentor to your team, manage their day to day activities and support their career aspirations.</p><p>&nbsp;</p><p><br></p><p>Qualifications</p><p><br></p><p>MSc in an analytics related subject</p><p>Strong statistical knowledge</p><p>Skills and experience</p><p><br></p>",
  department: {
    _id: "5a60c71e29c2585944f2a991",
    children: [],
  },
  client: {
    name: "Client Name",
    brand: {
      logo: "https://prweb-assets-prod.s3.amazonaws.com/55ca09a777f34605197e87ce/clients/google test logo.png",
    },
    _id: "58fe11207fec1a076a3683fa",
  },
  location: {
    locations: [
      {
        city: "Warwick",
        state: "NY",
        country: "US",
        county: "Orange",
        postalCode: "10990",
        type: "CITY",
        position: [-74.35988, 41.25648],
      },
    ],
    commuteDistance: 50,
    searchType: "DISTANCE",
    remote: "NONE",
    relocation: "NONE",
  },
  state: "UNVETTED",
  status: "ACTIVE",
  createdBy: {
    _id: "5ba9077f1a16ee1443a07ddf",
  },
  createdDate: 1608044223418,
  lastUpdated: 1610383406905,
  stateChanges: {
    ACTIVE: {
      timestamp: 1608044248861,
      user: {
        _id: "5ba9077f1a16ee1443a07ddf",
      },
    },
  },
  keywords: "product recruiter",
  keywordsActive: true,
  lastSearchId: "7278-127b-5c2f-c44c-9f07-3fc2-f6",
  lang: "en",
  activeWorkflowConfig: {
    template: {
      _id: "62d806887078fa3e523602de",
      latest: false,
      active: false,
    },
  },
  workflow: {
    _id: "62d806887078fa3e523602de",
    agency: {
      includeDisclaimer: false,
      _id: "55ca09a777f34605197e87ce",
    },
    createdBy: {
      _id: "56a837a6919c221a31da7e0f",
    },
    lastUpdatedBy: {
      _id: "56a837a6919c221a31da7e0f",
    },
    createdDate: 1658324616234,
    lastUpdatedDate: 1658978265836,
    version: 1,
    name: "ORGANIZATIONS DEFAULT WORKFLOW",
    type: "MATCH",
    latest: false,
    active: true,
  },
};

export const DefaultOppAttachmentRes = {
  total: 1,
  attachments: [
    {
      parentId: "5fd8cebfc44d6718100ee83b",
      parentType: "opportunity",
      fileName: "test 2.txt",
      fileType: "text/plain",
      uploadedDate: 1661540513280,
      portalVisibility: "VISIBLE",
      _id: "opportunity:5fd8cebfc44d6718100ee83b:c4698248d6cdbe86f0d7875ce6e3e28f",
    },
  ],
};
